import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import { tokens, Button, Text } from '@hotjar/hotsauce';
import type { OrganizationModel } from '@hotjar/webapp/domains/sso/model';

interface Props {
  organization: OrganizationModel;
  onClick: () => void;
}

const S = {
  Organization: styled.div`
    display: flex;
    justify-content: space-between;
    border-radius: ${tokens.radius.m};
    border: 1px solid ${tokens.color.ui_border};
    padding: ${tokens.spacer.x2};
    margin-top: ${tokens.spacer.x2};
  `,

  Value: styled(Text)`
    display: inline-flex;
    align-items: center;
  `,
};

export const OrganizationItem = ({ organization: { name }, onClick }: Props): JSX.Element => {
  const { t } = useTranslation();
  return (
    <S.Organization>
      <S.Value as="span" textType="subtitle2">
        {name}
      </S.Value>
      <Button icon="trash" kind="danger_secondary" onClick={onClick} size="s" type="button">
        {t('common:settings.sso.list-identity-providers.disconnect')}
      </Button>
    </S.Organization>
  );
};
